import { render, staticRenderFns } from "./action-sheet.vue?vue&type=template&id=70e80896&scoped=true&"
import script from "./action-sheet.vue?vue&type=script&lang=js&"
export * from "./action-sheet.vue?vue&type=script&lang=js&"
import style0 from "./action-sheet.vue?vue&type=style&index=0&id=70e80896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e80896",
  null
  
)

export default component.exports